<script setup>
import {Expand, InfoFilled} from "@element-plus/icons-vue";
import {onMounted, ref} from "vue";
import homeApi from "@/api/homeApi";

onMounted(()=>{
  getList()
})

const activeNames = ref([])
const linkedList = ref([])
const getList = () => {
  homeApi.getAllLinkedList({type:"0"}).then(res=>{
    linkedList.value = res
    activeNames.value = res.map(e=>e.id)
  })
}

const jumpNewPage = (linked) => {
  window.open(linked.link,"_blank")
}

const subLinkedList = ref([])
const showSubPopover = (linked) => {
  if(!subLinkedList.value[linked.id]){
    homeApi.getSubLinkedList({linkedId:linked.id}).then(res=>{
      subLinkedList.value[linked.id] = res
    })
  }

}
</script>

<template>
<div class="official-all">
  <div class="official-panel">
    <h2 style="text-align: center">官网链接</h2>
    <div>
      <el-collapse v-model="activeNames">
        <el-collapse-item v-for="(item,index) in linkedList" :name="item.id">
          <template #title>
              <div class="el-descriptions__title">{{item.name}}</div>
          </template>
          <el-row gutter="12" >
            <el-col v-for="(linked,lIndex) in item.linkedList" :span="6" style="margin-bottom: 12px">
              <el-card style="cursor: pointer;" shadow="hover">
                <div style="display: flex;height: 70px" @click="jumpNewPage(linked)">
                  <div style="padding: 0 12px 0 6px;display: flex;justify-content: center;align-items: center">
                    <el-image style="height:60px;width: 60px;" :src="'/api/record/img?path='+linked.icon"/>
                  </div>
                  <div style="flex: 1">
                    <el-text :line-clamp="1" size="large" tag="b">{{linked.name}}
                      <el-tag v-if="linked.proxy==='1'" type="primary" effect="plain" size="small">需代理 </el-tag>
                    </el-text>
                    <span style="float: right">
                    <el-popover
                        placement="right"
                        title="扩展网址"
                        :width="350"
                        :offset="20"
                        trigger="hover"
                        @before-enter="() => showSubPopover(linked)"
                    >
                      <template #reference>
                        <el-icon color="#A8ABB2" title="扩展网址"><Expand /></el-icon>
                      </template>
                      <el-table border size="small" :show-header="false" max-height="200px" :data="subLinkedList[linked.id]" style="width: 100%">
                        <el-table-column prop="name" width="80" label="名称"  />
                        <el-table-column prop="link" width="400" label="地址" >
                          <template #default="{row}">
                              <el-link type="primary" :href="row.link" target="_blank">{{row.link}}</el-link>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-popover>
                  </span>
                    <el-divider style="margin: 2px 0"/>
                    <el-text :line-clamp="2">{{linked.describe}}</el-text>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</div>
</template>

<style scoped lang="less">
.official-all{
  width: 1280px;
  margin: 24px auto;
  background: #f3f4f7;
}

.official-panel{
  border-radius: 12px;
  width: 100%;
  min-height: 500px;
  background: #ffffff;
  padding: 2px 24px;
}
</style>
<style lang="less">
.el-descriptions__body{
  .el-card__body{
  padding: 12px !important;
}
}
</style>